import { ADMINISTRATION_RIGHTS } from './administration';
import { ADMINISTRATOR_RIGHTS } from './administrator';
import { BUILDING_SERVICES_RIGHTS } from './building-services';
import { CAREGIVER_RIGHTS } from './caregiver';
import { FACILITY_MANAGEMENT_RIGHTS } from './facility-management';
import { GLOBAL_ADMIN_RIGHTS } from './globalAdmin';
import { HOUSEKEEPING_RIGHTS } from './housekeeping';
import { HOUSEKEEPING_MANAGEMENT_RIGHTS } from './housekeeping-management';
import { KITCHEN_RIGHTS } from './kitchen';
import { KITCHEN_MANAGEMENT_RIGHTS } from './kitchen-management';
import { NURSE_RIGHTS } from './nurse';
import { NURSING_ASSISTANT_TRAINED_RIGHTS } from './nursing-assistant-trained';
import { NURSING_ASSISTANT_UNTRAINED_RIGHTS } from './nursing-assistant-untrained';
import { NURSING_MANAGEMENT_RIGHTS } from './nursing-management';
import { QUALITY_OFFICER_RIGHTS } from './quality-officer';
import { RESIDENTIAL_AREA_MANAGEMENT_RIGHTS } from './residential-area-management';
import { SUPERVISION_MANAGEMENT_RIGHTS } from './supervision-management';
import { TRAINEE_RIGHTS } from './trainee';

export enum RoleName {
  ADMINISTRATOR = 'Administrator',
  FACILITY_MANAGEMENT = 'Einrichtungsleitung',
  NURSING_MANAGEMENT = 'Pflegedienstleitung',
  RESIDENTIAL_AREA_MANAGEMENT = 'Wohnbereichsleitung',
  QUALITY_OFFICER = 'QMB',
  NURSE = 'Pflegefachkraft',
  NURSING_ASSISTANT_TRAINED = 'Pflegehelfer mit Ausbildung',
  NURSING_ASSISTANT_UNTRAINED = 'Pflegehelfer',
  TRAINEE = 'Auszubildender',
  SUPERVISION_MANAGEMENT = 'Betreuungsleitung',
  CAREGIVER = 'Betreuungskraft',
  ADMINISTRATION = 'Verwaltung',
  KITCHEN_MANAGEMENT = 'Küchenleitung',
  KITCHEN = 'Küche',
  HOUSEKEEPING_MANAGEMENT = 'Hauswirtschaftsleitung',
  HOUSEKEEPING = 'Hauswirtschaft',
  BUILDING_SERVICES = 'Haustechnik',
  GLOBAL_ADMIN = 'Global Admin',
}

export const Roles = Object.freeze({
  /** Administrator */
  ADMINISTRATOR: ADMINISTRATOR_RIGHTS,
  /** Einrichtungsleitung */
  FACILITY_MANAGEMENT: FACILITY_MANAGEMENT_RIGHTS,
  /** Pflegedienstleitung */
  NURSING_MANAGEMENT: NURSING_MANAGEMENT_RIGHTS,
  /** Wohnbereichsleitung */
  RESIDENTIAL_AREA_MANAGEMENT: RESIDENTIAL_AREA_MANAGEMENT_RIGHTS,
  /** QMB */
  QUALITY_OFFICER: QUALITY_OFFICER_RIGHTS,
  /** Pflegefachkraft */
  NURSE: NURSE_RIGHTS,
  /** Pflegehelfer mit Ausbildung */
  NURSING_ASSISTANT_TRAINED: NURSING_ASSISTANT_TRAINED_RIGHTS,
  /** Pflegehelfer */
  NURSING_ASSISTANT_UNTRAINED: NURSING_ASSISTANT_UNTRAINED_RIGHTS,
  /** Auszubildender */
  TRAINEE: TRAINEE_RIGHTS,
  /** Betreuungsleitung */
  SUPERVISION_MANAGEMENT: SUPERVISION_MANAGEMENT_RIGHTS,
  /** Betreuungskraft */
  CAREGIVER: CAREGIVER_RIGHTS,
  /** Verwaltung */
  ADMINISTRATION: ADMINISTRATION_RIGHTS,
  /** Küchenleitung */
  KITCHEN_MANAGEMENT: KITCHEN_MANAGEMENT_RIGHTS,
  /** Küche */
  KITCHEN: KITCHEN_RIGHTS,
  /** Hauswirtschaftsleitung */
  HOUSEKEEPING_MANAGEMENT: HOUSEKEEPING_MANAGEMENT_RIGHTS,
  /** Hauswirtschaft */
  HOUSEKEEPING: HOUSEKEEPING_RIGHTS,
  /** Haustechnik */
  BUILDING_SERVICES: BUILDING_SERVICES_RIGHTS,
  /** Global Admin */
  GLOBAL_ADMIN: GLOBAL_ADMIN_RIGHTS,
});
